<template>
    <div>
        <div v-show="apiData.uid" class="apiContainner">
            <h2 class="api_title">基本信息</h2>
            <div class="api_pannel">
                <!-- <div class="col_row">
                    <div class="col_key">接口标题：</div>
                    <div class="col_val">
                        {{ apiData.title }}
                    </div>
                </div> -->
                <div class="col_row">
                    <div class="col_key">接口地址：</div>
                    <div class="col_val">
                        {{ apiData.path }}
                    </div>
                </div>
            </div>

            <h2 class="api_title">请求参数</h2>

            <h3 v-if="reqDataHeaders.length > 0" style="margin-top:20px;">Headers:</h3>
            <a-table v-if="reqDataHeaders.length > 0" class="reqTable" :pagination="false" :columns="columnsHeaders"
                :data-source="reqDataHeaders" bordered style="margin:20px 0;" rowKey="_id">
            </a-table>

            <h3 v-if="reqDataQuery.length > 0" style="margin-top:20px;">Query:</h3>
            <a-table v-if="reqDataQuery.length > 0" class="reqTable" :pagination="false" :columns="columnsReq"
                :data-source="reqDataQuery" bordered style="margin:20px 0;" rowKey="_id">
            </a-table>

            <h3 v-if="reqDataBody.length > 0">Body:</h3>
            <a-table v-if="reqDataBody.length > 0" class="reqTable" :pagination="false" :columns="columnsRes"
                :data-source="reqDataBody" bordered style="margin:20px 0;" rowKey="key">
            </a-table>

            <h2 class="api_title">返回数据</h2>

            <a-table
                :columns="columnsRes"
                :data-source="resData"
                :pagination="false"
                :expanded-row-keys.sync="expandedRowKeys"
                rowKey="key"
                bordered style="margin:20px 0;"
            />
        </div>
        <a-result title="请导入Yapi" v-show="!apiData.uid">
        </a-result>
    </div>
</template>
<script>


const columnsReq = [
    {
        title: "参数名称",
        dataIndex: "name",
        align: "center",
        width:100
    },
    {
        title: "是否必须",
        dataIndex: "required",
        align: "center",
        customRender: (text) => {
            return text == '1' ? '是' : '否';
        },
        width:100
    },
    {
        title: "示例",
        dataIndex: "example",
        align: "center",
        width:100
    },
    {
        title: "备注",
        dataIndex: "desc",
        align: "center",
        width:100
    },
]

const columnsRes = [
    {
        title: '名称',
        dataIndex: 'title',
        key:'title',
        width:'30%'
    },
    {
        title: '类型',
        dataIndex: 'type',
        key:'type'
    },
    {
        title: '是否必须',
        dataIndex: 'required',
        customRender: (text) => {
            return text == '1' ? '必须' : '非必须';
        },
        key:'required',
        width:100,
        align:'center'
    },
    {
        title: '描述',
        dataIndex: 'description',
        key:'description'
    },
];

const columnsHeaders = [
    {
        title: '参数名称',
        dataIndex: 'name',
        key:'name',
    },
    {
        title: '参数值',
        dataIndex: 'value',
        key:'value'
    },
    {
        title: '是否必须',
        dataIndex: 'required',
        customRender: (text) => {
            return text == '1' ? '是' : '否';
        },
        key:'required'
    },
    {
        title: '示例',
        dataIndex: 'example',
        key:'example'
    },
    {
        title: '备注',
        dataIndex: 'desc',
        key:'desc'
    },
];

export default {
    components:{
    },
    data() {
        return {
            apiData:{
                uid:'',
                title:'',
                path:'',
                req_query:'',
                res_body:'',
                res_body_type:'json'
            },
            columnsHeaders,
            columnsReq,
            columnsRes,
            reqDataHeaders:[],
            reqDataQuery:[],
            reqDataBody:[],
            resData:[],
            expandedRowKeys: [],
            tKey:1,
        };
    },
 
    methods: {
        handleChild(resData){
            let rData = {
                key:this.tKey,
                type:resData.type,
                title:resData.title || '',
                description:resData.description || '',
                required:resData.required || ''
            }
            this.expandedRowKeys.push(this.tKey);
            this.tKey++;

            if(rData.title == 'empty object'){
                rData.title = ''
            }
            //递归原始数据，生成树形结构
            if(resData.type == 'array'){
                //数组格式
                let tempObj = this.handleChild(resData.items);
                rData.children = [tempObj]
                //解析items
            }
            else if(resData.type == 'object'){
                rData.children = this.handleObject(resData)
                
            }
            return rData;
        },
        handleObject(resData){
            let result = [];
            for (const key in resData.properties) {
                if (resData.properties.hasOwnProperty(key)) {
                    const element = resData.properties[key];
                    element.title = key;
                    if(resData.required){
                        element.required = resData.required.indexOf(key) == -1 ? '0':'1'
                    }
                    else{
                        element.required = ''
                    }
                    let tc = this.handleChild(element);
                    result.push(tc)
                }
            }
            return result;
        },
        handleData(data){
            this.tKey = 1;
            let tempObj  = this.handleChild(data);
            return tempObj.children
        },
        renderYapiHtml(temData){
            this.apiData = temData;
            if(temData.req_headers){
                if(typeof(temData.req_headers) == 'string'){
                    this.reqDataHeaders = JSON.parse(temData.req_headers)
                }
                else{
                    this.reqDataHeaders = temData.req_headers
                }
            }
            else{
                this.reqDataHeaders = [];
            }
            if(temData.req_query){
                if(typeof(temData.req_query) == 'string'){
                    this.reqDataQuery = JSON.parse(temData.req_query)
                }
                else{
                    this.reqDataQuery = temData.req_query
                }
            }
            else{
                this.reqDataQuery = [];
            }
            if(temData.req_body_other){

                if(typeof(temData.req_body_other) == 'string'){
                    this.reqDataBody = this.handleData(JSON.parse(temData.req_body_other))
                }
                else{
                    this.reqDataBody = this.handleData(temData.req_body_other)
                }
            }
            else{
                this.reqDataBody = [];
            }

            if(temData.res_body){
                if(typeof(temData.res_body) == 'string'){
                    this.resData = this.handleData(JSON.parse(temData.res_body))
                }
                else{
                    this.resData = this.handleData(temData.res_body)
                }
            }
            else{
                this.resData = [];
            }
            
        },
        handleReqParams(){

        }
    },
    mounted(){
    }
};
</script>

<style scoped>
    .apiContainner{
        font-size: 14px;
    }
    .api_title{
        clear: both;
        font-weight: 400;
        margin-top: .48rem;
        margin-bottom: .16rem;
        border-left: 3px solid #2395f1;
        padding-left: 16px;
        background: #f7f8fa;
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .api_pannel{
        margin: 8px 0;
        padding: 16px;
        width: 100%;
        box-sizing: border-box;
    }
    .col_row{
        margin-bottom: .16rem;
        line-height: 36px;
        position: relative;
        margin-left: 0;
        margin-right: 0;
        height: auto;
        display: block;
        box-sizing: border-box;
    }
    .col_key{
        font-weight: 700;
        text-align: left;
        width: 100px;
        padding-left: 10px;
        display: inline;
    }
    .col_val{
        display: inline;
    }
  

</style>
